module.exports = __webpack_public_path__ + "static/media/undraw_empty.5fd6f2b8.svg";